import { Component, OnInit, Input } from '@angular/core';
import { ApplicationService } from '../../application/application.service';
import { Application, EmiOption } from '../application';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'zest-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input() emiOption: EmiOption;
  @Input() application: Application;

  public s3BucketUrl: string = environment.s3BucketUrl;

  constructor(private applicationSerice: ApplicationService) { }

  ngOnInit() {
    const interval = setInterval(fn => {
      this.application = this.applicationSerice.getApplication();
      if (this.application !== null) {
        clearInterval(interval);
      }
    }, 100);
  }

}
